import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Header from '../../components/header_home'
import MissionCardMobile from '../../components/mission_card/mobile'
import Tour from '../../components/tour'
import { useGame, useTour, usePage, useGameWrapper } from '../../contexts'
import { MissionModel } from '../../../domain/model/mission.model'
import { getTeam } from '../../utils/team_helpers'
import { groupIsComplete, orderByPosition } from '../../utils/mission_helpers'
import { addLocalStorage, clearGame, getLocalStorage, removeLocalStorage } from '../../utils/storage_helpers'
import { GameModel } from '../../../domain/model/game.model'
import SliderDrag from '../../components/ui/components/slider-drag'
import Loading from '../../components/loadings/simple'
import { isAuthenticatedUser } from '../../utils/storage/user'
import {
  Wrapper,
  MissionContainerMobile,
  Title,
  TitleWrapper,
  Content,
  MissionContainerMobileFinished,
  Mobile,
  Item,
  HomeWrapper,
  Subtitle,
  Subtext, FinishedMissionsDesktop,
  AvailableMissionContent
} from './styles'
import { makeCurrentUser } from '../../../main/usecases/users/users-factory'
import { show4Items } from '../../utils/responsive'
import { logOut } from '../../utils/auth_helpers'
import { t } from '../../adapters/translate/translate'
import { GameState } from '../../../domain/enum/game-state.enum'
import { isMobile } from '../../utils/general'

export type IMissionProps = {
  id: string;
  name: string;
  type: 'done-group' | 'done' | 'current' | 'blocked';
  hasGift?: boolean;
  points?: number;
  isMobileVersion: boolean;
}

const Home = () => {
  const [missions, setMissions] = useState<IMissionProps[]|any>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const isMobileVersion = isMobile()

  const navigate = useNavigate()
  const { game, setPoints } = useGame()
  const { handleToggleCurrentMission } = useGameWrapper()
  const { toggleHeaderConfig } = usePage()
  const { handleToggleTour, currentStep, tourWasCompleted, showInstructions } = useTour()

  function handleGoToMission (mission:MissionModel) {
    handleToggleCurrentMission(mission)
    navigate('/mission')
  }

  function focusCurrentMission () {
    setTimeout(() => {
      const currentMissionEl = document.querySelector('[type=current].not-first')
      if (currentMissionEl) currentMissionEl.scrollIntoView()
    }, 200)
  }

  function addStatusInGameMissionsInterna () {
    const localAnswers = JSON.parse(getLocalStorage('localAnswers') || '[]')
    setMissions((state: MissionModel[]) => {
      return state.map((mission: MissionModel, idx: number) => {
        mission.status = idx === 0 ? 'current' : 'blocked'
        if (localAnswers.find((item:any) => item.uuid === mission.uuid)) mission.status = 'done-group'

        mission.childMissions = mission.childMissions.sort(orderByPosition).map((missionChild: MissionModel) => {
          missionChild.status = 'blocked'
          if (localAnswers.find((item:any) => item.uuid === missionChild.uuid)) mission.status = 'done'
          return missionChild
        }, [])

        return mission
      })
    })
  }

  async function loadPageSettings () {
    const isLogged = await isAuthenticatedUser()
    if (isLogged) {
      const user = await makeCurrentUser().load()
      const data: GameModel = user?.team?.games[0]
      setPoints(user.points)

      if (!data) {
        await logOut()
      }

      if (getLocalStorage('gameCode') !== data.code) {
        clearGame()
      }

      addLocalStorage('gameCode', '' + data.code)

      setMissions(data?.missions.sort(orderByPosition).filter((item: MissionModel) => item.isParent && item.type !== 'welcome' && item.type !== 'instructions'))
      if (!data?.missions?.find((item: MissionModel) => item.type === 'welcome')?.responded) {
        await redirectToInicialMissions(data?.missions?.find((item: MissionModel) => item.type === 'welcome'), 'welcome')
        return
      }

      if (!data?.missions?.find((item: MissionModel) => item.type === 'instructions')?.responded) {
        await redirectToInicialMissions(data?.missions?.find((item: MissionModel) => item.type === 'instructions'), 'instructions')
        return
      }

      addStatusInGameMissionsInterna()
      toggleHeaderConfig({ type: 'title', title: getLocalStorage('gameTitle') || t('Game Journey'), teamName: getTeam()?.name })
      removeLocalStorage('currentMission')
      removeLocalStorage('currentParent')
      removeLocalStorage('currentChildren')
      if (tourWasCompleted) focusCurrentMission()
      setIsLoading(false)
    } else {
      navigate('/login')
    }
  }

  async function redirectToInicialMissions (greetingsMission:MissionModel|any, type:string) {
    const alreadyResponded = greetingsMission?.responded
    if (!alreadyResponded) {
      if (type === 'welcome') {
        await navigate('/greetings')
      } else if (type === 'instructions') {
        await navigate('/instructions')
      }
    }
  }

  function parentHandle (mission:MissionModel) {
    const childMission = mission?.childMissions.find((item:any) => !item.responded)
    if (!mission.responded) {
      handleGoToMission(mission)
      return
    }
    if (childMission) {
      handleGoToMission(childMission)
    }
  }

  useEffect(() => {
    loadPageSettings()
  }, [game])

  useEffect(() => {
    if (game.gameState !== GameState.APPROVAL) {
      const alreadyGoToGreetingsPage = getLocalStorage('greetings') || null
      if (!tourWasCompleted && alreadyGoToGreetingsPage && !isLoading && showInstructions) {
        handleToggleTour()
      }

      if (currentStep.className === 'tour-2') {
        toggleHeaderConfig({ type: 'timer' })
      }
      if (tourWasCompleted) {
        toggleHeaderConfig({ type: 'title', title: getLocalStorage('gameTitle') || t('Game Journey'), teamName: getTeam()?.name })
      }
    }
  }, [currentStep, tourWasCompleted, isLoading, showInstructions, game])

  // mobile grouped by 4 or 2
  const getGroupedMissionsItems = (missions: any[]) => {
    const lenght = missions.length
    let base = 0
    let mod = 8
    const array = []

    if (!isMobileVersion) {
      return missions
    }

    if (lenght === 0) return []

    if (show4Items()) {
      mod = 8
    } else {
      mod = 2
    }

    if (lenght <= base + mod) {
      array.push(missions)
      console.log(array, 'ar1')
      return array
    }

    const loop = Math.ceil(lenght / mod)

    for (let i = 0; i < loop; i++) {
      if (lenght <= base + mod) {
        array.push(missions.slice(base, lenght))
        console.log(array, 'ar2')
        return array
      }
      array.push(missions.slice(base, base + mod))
      base = base + mod
    }
    console.log(array, 'ar3')
    return array
  }

  const getRespondedMissions = () => {
    return missions.filter((mission:MissionModel) => mission.responded && mission.isParent && !mission.childMissions.some(child => !child.responded))
  }

  const getAllowedMissions = () => {
    return missions.filter((mission: any) => !groupIsComplete(mission) && mission.status !== 'done-group').sort(orderByPosition)
  }

  return (
    <Wrapper>
      <Header />
      <HomeWrapper>

        {
          isLoading
            ? (
            <Loading />
              )
            : (
            <Mobile $isMobile={isMobileVersion} finishedMissions={!!missions.length && !!getRespondedMissions().length}>
            {isMobileVersion && (
              <TitleWrapper>
                <h3>{t('Team')}</h3>
                <Title color={game?.baseColor}>{getTeam().name}</Title>
              </TitleWrapper>
            )}

              {!!missions.length && !!getRespondedMissions().length && <Subtitle $isMobile={isMobileVersion}>
                {t('Finished missions')}
              </Subtitle>}
              {
                // FINISH MISSIONS
                !!missions.length && !!getRespondedMissions().length &&
                  <MissionContainerMobileFinished $isMobile={isMobileVersion}>
                    <Content $isMobile={isMobileVersion}>
                      {isMobileVersion
                        ? <SliderDrag>
                            {
                              getGroupedMissionsItems(getRespondedMissions().sort(orderByPosition))
                                .map((missions: any[], index: number) => (
                                <Item key={index}>
                                  {
                                    missions && missions.length > 0 && missions.map((mission:any, idx:number) => (
                                      <MissionCardMobile
                                        key={idx}
                                        onAction={parentHandle}
                                        points={mission.pointsIfCorrect}
                                        mission={mission}
                                        color={game?.baseColor}
                                        textColor="#1E1E1E"
                                        finished
                                        $isMobile={isMobileVersion}
                                      />
                                    ))
                                  }
                                </Item>
                                ))
                            }
                          </SliderDrag>
                        : <FinishedMissionsDesktop>
                          {getGroupedMissionsItems(getRespondedMissions().sort(orderByPosition))
                            .map((mission, index: number) => (
                              <MissionCardMobile
                                key={index + 1}
                                onAction={parentHandle}
                                points={mission.pointsIfCorrect}
                                mission={mission}
                                color={game?.baseColor}
                                textColor="#1E1E1E"
                                finished
                                $isMobile={isMobileVersion}
                              />
                            ))}
                        </FinishedMissionsDesktop>
                      }

                    </Content>
                  </MissionContainerMobileFinished>
              }
              <Subtitle className={
                      (currentStep.className === 'tour-1' && !tourWasCompleted
                        ? 'tour-1 '
                        : ''
                      )
                    }
                $isMobile={isMobileVersion}
              >
                {t('Allowed missions')}
              </Subtitle>
              {
                // ALLOWED MISSIONS
                !!missions.length && !!getAllowedMissions().length &&
                  <MissionContainerMobile>
                    <AvailableMissionContent $isMobile={isMobileVersion}>
                      {getAllowedMissions().map((mission:any, idx:number) => (
                        <MissionCardMobile
                          key={idx}
                          firstMission={idx === 0}
                          finishedMissions={getRespondedMissions().length}
                          onAction={parentHandle}
                          points={mission.pointsIfCorrect}
                          mission={mission}
                          color={game?.baseColor}
                          textColor="#1E1E1E"
                          $isMobile={isMobileVersion}
                          totalMission={missions.length}
                        />
                      ))}
                    </AvailableMissionContent>
                  </MissionContainerMobile>
              }
              {
                // NO MISSION
                missions.length === 0 && (<Subtext>{t('No missions until now')}</Subtext>)
              }
              {
                // THERE ARE MISSIONS BUT NOT TO ANSWEAR
                missions.length > 0 && getGroupedMissionsItems(missions.filter((mission: any) => !groupIsComplete(mission) && mission.status !== 'done-group').sort(orderByPosition)).length === 0 && (<Subtext>{t('Good! You finished all available missions!')}</Subtext>)
              }
            </Mobile>
              )
        }
      </HomeWrapper>
      <Tour />
    </Wrapper>
  )
}

export default Home
